export default ({
  path: "/register",
  name: "register",
  component: () => import("@/views/register/Register.vue"),
  meta: {
    title: "Register - Self-Assessment and Quality Improvement Planning Portal"
  },
  children: [
    {
      path: "onboarding",
      name: "register-onboarding",
      component: () => import("@/views/register/RegisterOnboarding.vue"),
      meta: {
        title: "Register - Self-Assessment and Quality Improvement Planning Portal"
      }
    },
    {
      path: "account",
      name: "register-account",
      component: () => import("@/views/register/RegisterAccount.vue"),
      meta: {
        title: "Register - Self-Assessment and Quality Improvement Planning Portal"
      }
    },
    {
      path: "identity/onboarding",
      name: "register-identity-onboarding",
      component: () => import("@/views/register/RegisterIdentityOnboarding.vue"),
      meta: {
        title: "Register - Self-Assessment and Quality Improvement Planning Portal"
      }
    },
    {
      path: "identity",
      name: "register-identity",
      component: () => import("@/views/register/RegisterIdentity.vue"),
      meta: {
        title: "Register - Self-Assessment and Quality Improvement Planning Portal"
      }
    },
    {
      path: "confirm",
      name: "register-confirm",
      component: () => import("@/views/register/RegisterConfirm.vue"),
      meta: {
        title: "Register - Self-Assessment and Quality Improvement Planning Portal"
      }
    },
    {
      path: "complete",
      name: "register-complete",
      component: () => import("@/views/register/RegisterComplete.vue"),
      meta: {
        title: "Register - Self-Assessment and Quality Improvement Planning Portal"
      }
    }
  ]
})